import { render, staticRenderFns } from "./RestApi.vue?vue&type=template&id=aa456bda&scoped=true"
import script from "./RestApi.vue?vue&type=script&lang=js"
export * from "./RestApi.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa456bda",
  null
  
)

export default component.exports